import { Button, Icon } from "@repo/ui";
import { useTranslation } from "react-i18next";
import { useTheme } from "@repo/tokens";
import styles from "./FlashcardsWebHeader.module.scss";

export function FlashcardsWebHeader({
  onClose,
  topicName,
  topicAlignStart,
}: {
  onClose: () => void;
  topicName?: string;
  topicAlignStart?: boolean;
}) {
  const { t } = useTranslation("selflearn");
  const { theme } = useTheme();
  const closeLabel = t("flashcards.a11y.close");

  const rootClass =
    topicAlignStart === true
      ? `${styles.root} ${styles.rootTopicStart}`
      : styles.root;

  return (
    <header className={rootClass}>
      {topicName ? <h1 className={styles.topic}>{topicName}</h1> : null}
      <div className={styles.headerActions}>
        <Button
          variant="ghost"
          size="lg"
          onPress={onClose}
          aria-label={closeLabel}
          accessibilityLabel={closeLabel}
          leftIcon={
            <span className={styles.iconWrapper}>
              <Icon name="close" size={24} color={theme.text.primary} />
            </span>
          }
        />
      </div>
    </header>
  );
}
